var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',[_vm._v("E-Mailadresse des Terminverwalters")]),_c('inputEmail',{attrs:{"data":_vm.email,"label":"","callback":_vm.setEmail}}),_c('info',[_vm._v(" Per E-Mail über eingehende Termine benachrichtigen ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }